import { getService } from 'react-in-angularjs';
import { resetAllStore } from '../../../stores/resetAllStore';
import { ANGULAR_EVENT_KEYS } from '../../../constants/system/ANGULAR_EVENT_KEYS';
import { broadcastEvent } from '../../angularUtils';
import { reloadOtherTabs } from '../../windowUtils';

type ClearUserInfoOptions = {
  // Suppress cross-tab reload signal. Used by setUserInfo, which signals once init completes.
  skipTabReload?: boolean;
};

export const clearUserInfo = ({ skipTabReload }: ClearUserInfoOptions = {}) => {
  const localStorageService = getService('localStorageService');

  // Clear stores first to prevent persistence during clearing
  resetAllStore.reset();

  // Then clear storage
  localStorageService.clearAll();
  localStorage.clear();

  if (!skipTabReload) {
    reloadOtherTabs();
  }

  broadcastEvent(ANGULAR_EVENT_KEYS.UPDATE_USER);
};
